import { Component, ElementRef, Injector, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { InvalidfileextensionsService } from '../../main-layout/invalidfileextensions/invalidfileextensions.service';
import { BaseClass } from '../../utility/baseClass';
import { Invalidfileextensions } from '../../utility/modals';
import { Utilityservice } from '../../utility/utilityservice.service';
import { VALIDATION_PATTERNS } from '../../utility/validation-patterns';

@Component({
  selector: 'app-invalidfileextensionsmodal',
  templateUrl: './invalidfileextensionsmodal.component.html',
  styleUrls: ['./invalidfileextensionsmodal.component.css']
})
export class InvalidfileextensionsmodalComponent extends BaseClass implements OnInit {

  tableData: any[] = [];
  dataList = [];
  userlist = [];
  userdata = [];
  nameReadonly = false;
  emailReadonly = false;
  details: any;
  datas: any;
  dataarray: Array<Invalidfileextensions>;
  saveTitle = 'Add';
  public dataForm: FormGroup;
  onlyView: boolean = false
  isEdit: boolean = false;
  Datadetails: any = {};
  CSRFToken = "";

  public validation_message = {
    fileextension: [
      { type: 'required', message: 'File Extension is required' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning or end' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: 'Special characters are not allowed ( % and \' )' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' }
    ]
  }



  constructor(
    public thisService: InvalidfileextensionsService,
    private fb: FormBuilder,
    public utilityservice: Utilityservice,
    private el: ElementRef,
    public router: Router,
    public override  injector: Injector,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig, private spinnerservice: NgxSpinnerService
  ) {
    super(injector);
    this.gettoken();
    const dataFromParent = this.config.data;
    if (dataFromParent?.title == 'Modify Invalid File Extension') {
      this.isEdit = true;
      this.saveTitle = 'Modify'
      this.Datadetails = dataFromParent.datas
    }
  }

  gettoken() {
    this.CSRFToken = '';
    this.spinnerservice.show()
    this.utilityservice.getCSRFtoken().subscribe(res => {
      this.spinnerservice.hide();
      this.CSRFToken = res.csrf;
    }, error => {
      this.spinnerservice.hide();
      Swal.fire(error.error.message, '', 'error');
    });
  }

  ngOnInit() {
    this.formInitiliaze();
    this.getData();
  }


  formInitiliaze() {
    this.dataForm = this.fb.group({
      fileextension: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(10),
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
        Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW)
      ])],
      activeflag: [''],
      rid: ['']
    })

  }

  getData() {
    this.patchValueForms(this.Datadetails[0])
  }

  patchValueForms(data) {
    if (this.isEdit) {
      this.dataForm.patchValue({ 'id': data.id });
      this.dataForm.patchValue({ 'fileextension': data.fileextension });
    }
  }


  dismiss() {
    Swal.fire({
      title: "Are you sure you want to close?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "No",
      denyButtonText: `Yes`
    }).then((result) => {
      if (result.isDenied) {
        this.ref.close();
      }
    });
  }

  tempdata: any;
  add() {
    if (this.dataForm.invalid) {
      this.validateAllFormFields(this.dataForm);
    }
    else {
      if (this.saveTitle == 'Modify') {
        this.modifySignatory(this.dataForm.value)
      }
      else {
        const datapayload = {
          fileextension: this.dataForm.get('fileextension').value,
          csrftoken: this.CSRFToken

        }
        Swal.fire({
          title: "Do you want to save the changes?",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "Save",
          denyButtonText: `Don't Save`
        }).then((value) => {
          if (value.isConfirmed) {
            this.thisService.add(datapayload).subscribe((data) => {
              this.tempdata = data;
              if (this.tempdata.response == 'exists') {
                Swal.fire("Invalid File extension already exists!", "", "error").then(() => {
                  this.ref.close()
                });
              }
              else {
                Swal.fire("File Extension is added successfully!", "", "success").then(() => { this.ref.close() });
              }

            },
              error => {
                if(error.error.response == 'html') {
                  Swal.fire("The data you entered contains HTML or JavaScript code, which is not allowed. Please remove the HTML or JavaScript content and try again.", "", "error").then(result => {
                  })
                  }       
                else{
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: error.error.error,
                  footer: "error status is :" + ' ' + error.status
                });}
              });
          } else if (value.isDenied) {
            Swal.fire("Changes are not saved", "", "info")
            this.ref.close()
          }
        });
      }
    }
  }

  //Modify DATA
  tempDataUpdate: any;
  modifySignatory(data: any) {
    Swal.fire({
      title: "Do you want to save the changes?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Save",
      denyButtonText: `Don't Save`
    })
      .then((value) => {
        if (value.isConfirmed) {
          data.rid = this.Datadetails[0].id
          data.fileextension = this.dataForm.get('fileextension').value;
          data.csrftoken = this.CSRFToken;
          this.thisService.modify(this.dataForm.value).subscribe((data) => {
            this.tempDataUpdate = (data);
            if (this.tempDataUpdate.response == 'exists') {
              Swal.fire("File Extension already exists!", "", "error").then(() => {
                this.ref.close()
              });
            }
            else {
              Swal.fire("File Extension is modified successfully!", "", "success").then(() => { this.ref.close() });
            }
          }, error => {
            if(error.error.response == 'html') {
                  Swal.fire("The data you entered contains HTML or JavaScript code, which is not allowed. Please remove the HTML or JavaScript content and try again.", "", "error").then(result => {
                  })
                  }       
                else{
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: error.error.error,
                  footer: "error status is :" + ' ' + error.status
                });}
          });
        }
        else if (value.isDenied) {
          Swal.fire("Changes are not saved", "", "info")
          this.ref.close()
        }
      });

  }
}
